



























import { Component, Vue } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue'
import DashboardBookingRoleStatistics from '@/components/BookingRoles/DashboardBookingRoleStatistics.vue';
import KpiDashboard from '@/components/KpiTargets/KpiDashboard.vue';
import JobSchedule from '@/components/Jobs/JobSchedule.vue';
import JobScheduleSearchCriteria from '@/components/Jobs/JobScheduleSearchCriteria.vue';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import { AgencyDashboardModule } from '@/store/modules/agencyDashboard';
import { AgencyScheduleModule } from '@/store/modules/agencySchedule';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
	name: 'AgencyDashboard',
  	components: { Alert, DashboardBookingRoleStatistics, KpiDashboard, JobSchedule, JobScheduleSearchCriteria }
})
export default class extends GiganautVue {

  public activeTab = 0;

  async beforeMount() {
    await AgencySettingsModule.getBranches();
    await AgencyDashboardModule.getCompaniesForSearchOptions();
    await AgencyDashboardModule.getLocationsForSearchOptions();
    await AgencyDashboardModule.mapUserDefaults();
    await AgencyDashboardModule.getBookingRoleStatistics();
    await AgencyScheduleModule.getCompaniesForSearchOptions();
    await AgencyScheduleModule.getLocationsForSearchOptions();
    await AgencyScheduleModule.mapUserDefaults();
    await AgencyScheduleModule.getJobSchedule();
  }

}
